import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

import { TextFormField } from '~components/FormFields/TextFormField';

interface Props<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors<TFieldValues>;
}
const Notes = <TFieldValues extends FieldValues>({
  control,
  errors,
}: Props<TFieldValues>) => (
  <Card sx={{ p: 2, mb: 2 }}>
    <Typography variant="form-section-title">{t('form_fields.notes')}</Typography>
    <TextFormField
      control={control}
      multiline={true}
      rows={2}
      errors={errors}
      name="notes"
      label=""
      isRequired={false}
    />
  </Card>
);

export { Notes };
